<template>
    <div>
        <div v-if="matchSummaryData && (homeTeam !== '' )" class="team-container">
            <div class="team-score">
                <div class="team">{{ homeTeam }}</div>
                <div class="score">{{ homeScore }}</div>
            </div>
            <div class="team-score">
                <div class="team">{{ awayTeam }}</div>
                <div class="score">{{ awayScore }}</div>
            </div>
        </div>
            
        <span class="game-phase">{{ matchSummary }}</span>
    </div>
</template>

<script>
    import { HubConnection } from '@aspnet/signalr';

    export default {
        name: 'MatchSummary',
        data() {
            return {
                matchSummary: null,
                homeTeam: '',
                awayTeam: '',
                homeScore: '',
                awayScore: ''
            }
        },
        props: {
            connection: HubConnection,
            sport: String,
            eventId: String,
            state: Array,
            matchSummaryData: Object,
            eventName: String,
        },
        methods: {
            updateGamestate(updatedGamestate) {
                if (updatedGamestate !== null && updatedGamestate.FixtureID === this.eventId) {
                    this.matchSummary = updatedGamestate && updatedGamestate.GameState[0].ConciseMatchSummary || this.buildConciseSummary(updatedGamestate.GameState[0].MatchSummary);
                   
                    if (updatedGamestate.GameState[0] && updatedGamestate.GameState[0].otherGameStates) {
                        let otherGameStates = this.formatGameState(updatedGamestate.GameState[0].otherGameStates);
                        this.buildScores(otherGameStates);
                    }
                    else {
                        this.extractScores(updatedGamestate.GameState[0].MatchSummary);
                    }
                }
            },
            formatGameState(otherGameStates) {
                otherGameStates.forEach(element => {
                    element.gameStateName = element.GameStateName;
                    element.gameStateValue = element.GameStateValue;
                    delete element.GameStateName;
                    delete element.GameStateValue;
                });
                return otherGameStates;
            },
            buildGameState() {
                this.matchSummary = this.matchSummaryData && this.matchSummaryData.gameState && this.matchSummaryData.gameState[0].conciseMatchSummary || this.buildConciseSummary(this.matchSummaryData.gameState[0].matchSummary);

                if (this.matchSummaryData && this.matchSummaryData.gameState[0] && this.matchSummaryData.gameState[0].otherGameStates) {
                    this.buildScores(this.matchSummaryData.gameState[0].otherGameStates);
                }
                else {
                    this.extractScores(this.matchSummaryData.gameState[0].matchSummary);
                }
            },
            buildScores(otherGameStates) {
                otherGameStates.forEach(element => {
                    if (element.gameStateName === 'HomeTeam') {
                        this.homeTeam = element.gameStateValue;
                    }
                    else if (element.gameStateName === 'AwayTeam') {
                        this.awayTeam = element.gameStateValue;
                    }

                    if (element.gameStateName === 'HomeScore') {
                        this.homeScore = element.gameStateValue;
                    }
                    else if (element.gameStateName === 'AwayScore') {
                        this.awayScore = element.gameStateValue;
                    }
                });
            },
            extractScores(matchSummary) {
                switch (this.sport) {
                    case 'Football':
                    let scores = matchSummary.match(/(\d+)-(\d+)/);
                    if (scores) {
                        this.homeScore = scores[1];
                        this.awayScore = scores[2];
                    }
                        break;
                
                    default:
                        break;
                }
            },
            splitEventName(eventName) {
                const regex = /\s+(v|@)\s+/i;
                const teams = eventName.split(regex);

                if (teams.length === 3) {
                    teams.splice(1, 1);
                    this.homeTeam = teams[0];
                    this.awayTeam = teams[1];
                }
            },
            buildConciseSummary(summary) {
                switch (this.sport) {
                    case 'Cricket':
                        if (summary.includes('1st Innings')) {
                            return '1st Innings';
                        }
                        else if (summary.includes('2nd Innings')) {
                            return '2nd Innings';
                        }
                        else if (summary.includes('3rd Innings')) {
                            return '3rd Innings';
                        }
                        else if (summary.includes('4th Innings')) {
                            return '4th Innings';
                        }
                        return summary;

                    case 'Football':
                        if (summary.includes('1st')) {
                            return '1st';
                        }
                        else if (summary.includes('2nd')) {
                            return '2nd';
                        }
                        else if (summary.includes('Halftime')) {
                            return 'HT';
                        }
                        
                        return summary;
                    case 'Tennis':
                        console.log(summary);
                        const matches = summary.match(/Set \d+ Game \d+/);
                        if (matches) {
                            return matches[0];
                        }
                        return summary;
                    default:
                        const score = this.homeScore + '-' + this.awayScore + ' ';
                        return summary && summary.replace(score, '');
                }
            }
        },
        mounted() {
            if (this.matchSummaryData && this.matchSummaryData.gameState && this.matchSummaryData.gameState[0]) {
                this.buildGameState();
            }
			
            if (this.sport !== "MotorSport" && (this.homeTeam === "" || this.awayTeam === "")){
                this.splitEventName(this.eventName);
            }
            if (this.connection) {
                this.connection.on(this.sport + "ms-rcv", (value) => {
                    if (value !== null) {
                        this.updateGamestate(JSON.parse(value));
                    }
                });
            }

        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .sub-header {
        padding-top: 10px;
        padding-bottom: 10px;
        display: inline-block;
        width: 100%;
        font-size: 15px;
        background-color: #5c1b7b;
    }

    span.match-summary-text {
        padding-left: 10px;
        text-align: left;
    }

    span.match-facts {
        text-align: right;
        float: right;
        padding-right: 10px;
        background-color: #46246d;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 10px;
        margin-top: -10px;
        margin-bottom: -10px;
    }

    .team-container {
        display: grid;
        grid-template-columns: auto 10px;
        gap: 20px;
    }

    .team-score {
        display: contents;
        font-weight: 600;
        font-size: 12px
    }

    .team {
        justify-self: start;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
        margin-right: 10px;
        font: normal normal normal 14px/20px Poppins;
    }

    .score {
        justify-self: start;
        font: normal normal normal 14px/20px Poppins;
    }

    .game-phase {
        left: 10px;
        position: absolute;
        bottom: 8px;
        color: #8066E9;
        font-size: 12px;
        text-overflow: ellipsis;
        width: 20%;
        white-space: nowrap;
        overflow: hidden;
        font-style: italic;
    }

    

    @media (max-width: 960px){
        .team-container {
            gap: 13px;
        }
        .team {
        max-width: 80%;
        padding-right: 0px;
        }
        .score {
        justify-self: end;
        }
        .game-phase {
            width: 51%;
        }
    }

</style>
